import React, { useState,useEffect } from "react";
import { Link,useLocation  } from "react-router-dom";
const TutorHeader =() => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path ? "active" : "";
    const tutor = JSON.parse(localStorage.getItem("tutor"));
    
    return (
      <>
       <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          {/* Navbar Header */}
          <div className="d-flex align-items-center p-2">
            <button
              type="button"
              id="sidebarCollapse"
              className="btn btn-info me-2"
            >
              <i className="fa fa-angle-left"></i>
            </button>
            <button
              className="btn btn-info d-md-none"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarContent"
              aria-controls="navbarContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="fa fa-align-justify"></span>
            </button>
          </div>
      
          {/* Collapsible Navbar Content */}
          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav ms-auto">
              {/* Dropdown Menu */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="profileDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa fa-user"></i> PROFILE
                </a>
                <ul className="dropdown-menu" aria-labelledby="profileDropdown">
                  <li>
                    <Link className="dropdown-item" to="/manager/view-profile">
                      VIEW PROFILE
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/manager/edit-profile">
                      UPDATE PROFILE
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/manager/change-password">
                      CHANGE PASSWORD
                    </Link>
                  </li>
                  <li>
                 {/*   <Link className="dropdown-item" to="/manager/current-subscription">
                      CURRENT SUBSCRIPTION
                    </Link> */}
                  </li>
                </ul>
              </li>
              {/* Logout Link */}
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/logout"
                >
                  <i className="fa fa-power-off"></i> Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
   
      </>
    );
  }
  export default TutorHeader;